import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './scripts/app';
import { hasRole } from './scripts/auth';

export const AuthLayout = ({ role }) => {
  const { currentUserToken, loading } = useAuth();

  if (loading || !currentUserToken) return;

  if (!hasRole(currentUserToken.claims.role, role)) {
    return <Navigate to="/404" replace />;
  }

  return <Outlet />;
};